import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import { IAppRootState } from '../../core/store';
import { subscriptionCreatorReducer } from './subscription-creator.reducer';
import {
	SubscriptionCreatorSliceKey,
	SubscriptionCreatorSliceState,
} from './subscription-creator.state';
import { subscriptionSimulatorReducer } from './subscription-simulator.reducer';
import {
	SubscriptionSimulatorSliceKey,
	SubscriptionSimulatorSliceState,
} from './subscription-simulator.state';
import { subscriptionReducer } from './subscription.reducer';
import {
	SubscriptionOriginalSliceState,
	SubscriptionSliceKey,
} from './subscription.state';

export const SubscriptionFeatureKey = 'project-subscription';

export interface SubscriptionFeatureState {
	[SubscriptionSliceKey]: SubscriptionOriginalSliceState;
	[SubscriptionCreatorSliceKey]: SubscriptionCreatorSliceState;
	[SubscriptionSimulatorSliceKey]: SubscriptionSimulatorSliceState;
}

export interface SubscriptionRootState extends IAppRootState {
	[SubscriptionFeatureKey]: SubscriptionFeatureState;
}

export const featureSelector = createFeatureSelector<SubscriptionFeatureState>(
	SubscriptionFeatureKey
);

export const subscriptionReducers: ActionReducerMap<SubscriptionFeatureState> =
	{
		[SubscriptionSliceKey]: subscriptionReducer,
		[SubscriptionCreatorSliceKey]: subscriptionCreatorReducer,
		[SubscriptionSimulatorSliceKey]: subscriptionSimulatorReducer,
	};
